import React from 'react'
import styles from './MainVisual.module.scss'
import FreelanceNo1 from 'images/spa/top/freelance_no_1.svg'
import MainVisualFeatures from 'images/spa/top/main_visual_features.svg'
import MainVisualFeaturesSp from 'images/spa/top/main_visual_features_sp.svg'
import MainVisualWorking from 'images/spa/top/main_visual_working.svg'
import { useWindowWidth } from 'spa/hooks/useWindowWidth'
import { breakpointsV2 } from 'spa/config/styled'
import { useIsMobile } from 'spa/member/hooks/v2/useIsMobile'

const notesClass = (isDesktop: boolean) => {
  const base = `flex flex-col items-start text-2XS text-member-gray-100 opacity-30 pt-XL px-M all:mx-auto tablet:text-XS tablet:pt-2XL ${styles.notes}`

  if (isDesktop) {
    return `${base} desktop:absolute desktop:pt-M desktop:mx-0 desktop:px-0`
  }

  return base
}

const notes = (isDesktop: boolean) => {
  return (
    <ol className={notesClass(isDesktop)} role="list">
      <li>*1 クラウドソーシングを専門に取り扱っている企業（上場企業）において、フリーランス登録数がNo.1（会社発表IR資料比較）</li>
      <li>*2 2025年1月末時点</li>
    </ol>
  )
}

export const StyledMainVisual: React.FC = () => {
  const windowWidth = useWindowWidth()
  const isDesktop = breakpointsV2.desktop <= windowWidth
  const isMobile = useIsMobile()

  return (
    <section className={`flex flex-col w-full items-center relative pt-2XL pb-L tablet:pt-11 desktop:pl-5XL desktop:block desktop:overflow-hidden ${styles.mainVisualContainer}`}>
      <section className={`flex justify-end ${styles.mainVisualTextContainer}`}>
        <div className={`flex flex-col items-center relative all:text-center desktop:items-start desktop:text-left ${styles.mainVisualText}`}>
          <img src={FreelanceNo1} alt="フリーランス登録数No.1" loading="lazy" className={styles.freelanceNo1} />
          <div className="flex flex-col pt-2XL pb-M gap-XS" style={{ wordBreak: 'keep-all' }}>
            <p className="text-XS font-bold tablet:text-L">
              エンジニア・デザイナーを<br />
              中心としたフリーランス エージェントサービス
            </p>
            <h2 className="text-3XL font-bold text-member-green-100 tablet:text-5XL">
              リモートワーク案件数<br />
              業界トップクラス
            </h2>
          </div>
          <img src={isMobile ? MainVisualFeaturesSp : MainVisualFeatures} alt="リモート案件90%・週3日〜・案件継続率90%以上" loading="lazy" />
          {isDesktop ? notes(true) : null}
        </div>
      </section>
      <section className={`desktop:flex desktop:justify-center desktop:absolute ${styles.mainVisualWorkingContainer}`}>
        <div className={`pt-M my-auto ${styles.mainVisualWorkingImageContainer}`}>
          <img src={MainVisualWorking} alt="work" loading="lazy" className={`mt-2XS desktop:mt-0 desktop:ml-M`} />
        </div>
      </section>
      {isDesktop ? null : notes(false)}
    </section>
  )
}
